export type PublicConfig = {
  elevenLabsAgentId: string;
  firstMonthPrice: number;
  recurringPrice: number;
};

export const fallbackConfig: PublicConfig = {
  elevenLabsAgentId: "",
  firstMonthPrice: 299,
  recurringPrice: 399,
};

export async function loadPublicConfig(): Promise<PublicConfig> {
  try {
    const response = await fetch("/api/public-config", { headers: { accept: "application/json" } });
    if (!response.ok) return fallbackConfig;
    const value = await response.json() as Partial<PublicConfig>;
    return {
      elevenLabsAgentId: String(value.elevenLabsAgentId || ""),
      firstMonthPrice: Number(value.firstMonthPrice) || fallbackConfig.firstMonthPrice,
      recurringPrice: Number(value.recurringPrice) || fallbackConfig.recurringPrice,
    };
  } catch {
    return fallbackConfig;
  }
}
